"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
const jsx_runtime_1 = require("react/jsx-runtime");
const SvgCheckAll = props => (0, jsx_runtime_1.jsxs)("svg", {
  "data-name": "Bold 2px/check_all",
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  ...props,
  children: [(0, jsx_runtime_1.jsx)("path", {
    "data-name": "Bold 2px/check_all background",
    fill: "none",
    d: "M0 0h24v24H0z"
  }), (0, jsx_runtime_1.jsxs)("g", {
    fill: "#2d5dec",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M16.707 8.707a1 1 0 00-1.414-1.414l-4.757 4.757 1.414 1.414z"
    }), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Subtract",
      d: "M6.307 14.892l-.014-.014-2.586-2.585a1 1 0 00-1.414 1.414l2.586 2.586a3 3 0 003.415.586z"
    }), (0, jsx_runtime_1.jsx)("path", {
      "data-name": "Vector 410 (Stroke)",
      d: "M21.707 8.657l-7.636 7.636a3 3 0 01-4.243 0l-2.585-2.586a1 1 0 011.414-1.414l2.586 2.586a1 1 0 001.414 0l7.636-7.636a1 1 0 011.414 1.414z"
    })]
  })]
});
exports.default = SvgCheckAll;